class BogaMembersList extends HTMLElement {
  get tabs() {
    return [...this.querySelectorAll('[role=tab]')];
  }

  get panels() {
    return [...this.querySelectorAll('[role=tabpanel]')];
  }

  get selected() {
    return this.querySelector('[role=tab][aria-selected=true]');
  }

  set selected(element) {
    this.selected?.setAttribute('aria-selected', 'false');
    element?.setAttribute('aria-selected', 'true');
    element?.focus();
    this.updateSelection();
  }

  connectedCallback() {
    this.generateIds();
    this.updateSelection();
    this.setupEvents();
    this.list = this.querySelector('.member-list');
    this.content = this.querySelector('.member-list__member-content');
    this.initial = true;

    this.observer = new IntersectionObserver(this.handleObserver.bind(this), {
      rootMargin: '0px 0px -300px 0px',
    });
    this.observer.observe(this.content);
    document.documentElement.style.setProperty('scroll-behavior', 'smooth');
  }

  handleObserver(entries) {
    entries.forEach((entry) => {
      // console.log(entry);
      if (this.initial && entry.isIntersecting) {
        this.selected = this.tabs[0];
        this.initial = false;
      }
    });
  }

  generateIds() {
    const prefix = Math.floor(Date.now()).toString(36);

    this.tabs.forEach((tab) => {
      const index = tab.dataset.index;
      const panel = this.panels[index];

      tab.id ||= `${prefix}-tab-${index}`;
      panel.id ||= `${prefix}-panel-${index}`;

      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('aria-labelledby', tab.id);
    });
  }

  updateSelection() {
    this.tabs.forEach((tab) => {
      const index = tab.dataset.index;
      const panel = this.panels[index];

      const isSelected = tab.getAttribute('aria-selected') === 'true';
      const isVisible = tab.offsetParent !== null;

      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');

      // Only activate the associated panel for visible tabs (i.e. desktop or mobile)
      if (isVisible) {
        panel.setAttribute('tabindex', isSelected ? '0' : '-1');
        panel.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
      }

      if (isSelected && isVisible) {
        console.log('selected', index, panel);
        panel.scrollIntoView();
        this.initial = false;
      }
    });
  }

  setupEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.content.classList.remove('member-list__member-content--keyboard');
        this.selected = tab;
      });

      tab.addEventListener('keydown', (e) => {
        this.content.classList.add('member-list__member-content--keyboard');

        if (e.key === 'ArrowLeft') {
          this.selected = tab.previousElementSibling ?? this.tabs.at(-1);
        } else if (e.key === 'ArrowRight') {
          this.selected = tab.nextElementSibling ?? this.tabs.at(0);
        }
      });
    });
  }
}

window.customElements.define('boga-members-list', BogaMembersList);
